import { render, staticRenderFns } from "./representativeInfo.vue?vue&type=template&id=40f71ffc"
import script from "./representativeInfo.vue?vue&type=script&lang=js"
export * from "./representativeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports